import React, { useRef } from 'react';
import './HowItWorks.css';

const steps = [
  {
    num: 1,
    title: 'Upload Your Crop Photo',
    desc: 'Take a clear, close-up photo of an affected tomato or maize leaf and upload it directly from your phone or computer.',
  },
  {
    num: 2,
    title: 'AI Analyses the Image',
    desc: 'Our deep-learning CNN model scans the image through multiple analysis layers, identifying disease patterns, discolouration, and lesion signatures.',
  },
  {
    num: 3,
    title: 'Get Your Instant Diagnosis',
    desc: 'Within 2 seconds, receive the disease name, a confidence percentage, a symptom summary, and step-by-step treatment recommendations.',
  },
  {
    num: 4,
    title: 'Act and Protect Your Crop',
    desc: 'Apply the suggested treatment plan right away, or share the diagnosis with an agricultural extension officer for further guidance.',
  },
];

export default function HowItWorks() {
  const fileRef = useRef();
  const [preview, setPreview] = React.useState(null);

  const handleFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = ev => setPreview(ev.target.result);
    reader.readAsDataURL(file);
  };

  return (
    <section id="how-it-works">
      <div className="container">
        <div className="row g-5 align-items-center">

          {/* ── Steps ── */}
          <div className="col-lg-6 reveal">
            <span className="section-label">Simple 4-Step Process</span>
            <h2 className="section-title mb-3">
              Leaf Photo to<br />
              <span className="accent">Diagnosis in 2 Seconds</span>
            </h2>
            <p className="section-desc mb-5">
              No agricultural expertise required. If you can take a photo, you can protect your crops.
            </p>
            {steps.map(s => (
              <div className="step-card" key={s.num}>
                <div className="step-num">{s.num}</div>
                <div>
                  <div className="step-title">{s.title}</div>
                  <p className="step-desc">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* ── Demo Upload ── */}
          <div className="col-lg-6 reveal">
            <div className="demo-upload-card" onClick={() => fileRef.current.click()}>
              <input
                type="file"
                ref={fileRef}
                accept="image/*"
                style={{ display: 'none' }}
                onChange={handleFile}
              />
              {preview
                ? <img src={preview} alt="preview" style={{ width: '100%', borderRadius: 12, maxHeight: 260, objectFit: 'cover', marginBottom: 12 }} />
                : <div className="demo-upload-icon">📷</div>
              }
              <h5 style={{ color: 'var(--cream)', marginBottom: 8 }}>
                {preview ? 'Image Ready — Scroll Down to Analyse' : 'Try a Quick Demo'}
              </h5>
              <p style={{ color: 'var(--text-muted)', fontSize: '.9rem', margin: 0 }}>
                {preview ? 'Head to the Detect section below to run a full analysis.' : 'Click or drag and drop any crop leaf image here to preview it.'}
              </p>
            </div>
            <div className="mt-3 text-center">
              <small style={{ color: 'var(--text-muted)' }}>
                <i className="bi bi-shield-check me-1" style={{ color: 'var(--green-accent)' }}></i>
                Your images are analysed securely and never stored without your consent.
              </small>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
